const moduleContexts = require.context('./modules', true, /index\.js$/)
const modules = {}

moduleContexts.keys().forEach(key => {
  const moduleName = getModuleNameByPath(key)
  modules[moduleName] = moduleContexts(key).default
})

function getModuleNameByPath(path, lastIndex = 2) {
  const pathSplit = path.split('/')
  return pathSplit[pathSplit.length - lastIndex]
}
const store = new Vuex.Store({
  state: {
    tagsList: [],
    // keep-alive 缓存
    noCacheList: [],
    collapse: false
  },
  mutations: {
    delTagsItem(state, data) {
      state
        .tagsList
        .splice(data.index, 1);
    },

    previousPage(state, data) {
      let n = null
      state.tagsList.forEach((i, index) => {
        if (i.path === data.fullPath) {
          n = index
        }
      })
      if (n) {
        state.tagsList.splice(n, 1)
      }
    },
    setTagsItem(state, data) {
      const { noCache = false, name } = data
      if (noCache) state.noCacheList.push(name)
      state.tagsList.push(data)
    },
    clearTags(state) {
      state.tagsList = []
    },
    closeTagsOther(state, data) {
      state.tagsList = data;
    },
    closeCurrentTag(state, data) {
      for (let i = 0, len = state.tagsList.length; i < len; i++) {
        const item = state.tagsList[i];
        if (item.path === data.$route.fullPath) {
          if (i < len - 1) {
            data
              .$router
              .push(state.tagsList[i + 1].path);
          } else if (i > 0) {
            data
              .$router
              .push(state.tagsList[i - 1].path);
          } else {
            data
              .$router
              .push("/");
          }
          state
            .tagsList
            .splice(i, 1);
          break;
        }
      }
    },
    // 侧边栏折叠
    handleCollapse(state, data) {
      state.collapse = data;
    }
  },
  actions: {},
  modules: {
    ...modules
  }
})
export default store
